// src/scripts/lib/api.ts

// Detecta entorno dev (Astro en 4321) y pega al back en 3000.
// En prod (Vercel), BASE = '' y se usará /api/... (con rewrites).
function resolveBase(): string {
  if (typeof window === 'undefined') return '';
  const { hostname, port } = window.location;
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  if (isLocal && port === '4321') return 'http://localhost:3000';
  return '';
}

function join(base: string, path: string) {
  if (!base) return path;
  return `${base.replace(/\/+$/,'')}${path.startsWith('/') ? '' : '/'}${path}`;
}

const BASE = resolveBase();

// --- Helpers HTTP ---
async function postJson<T = any>(path: string, payload: unknown): Promise<T> {
  const url = join(BASE, path);
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let detail = '';
    try { detail = JSON.stringify(await res.json()); } catch {}
    throw new Error(`POST ${path} -> ${res.status}. ${detail}`);
  }
  return res.json();
}

async function getJson<T = any>(path: string, init?: RequestInit): Promise<T> {
  const url = join(BASE, path);
  const res = await fetch(url, { cache: 'no-store', ...init });
  if (!res.ok) throw new Error(`GET ${path} -> ${res.status}`);
  return res.json();
}

// --- Reviews ---
export type ReviewPayload = { name: string; message: string; rating?: number };
export async function createReview(payload: ReviewPayload) {
  return postJson('/api/reviews', payload);
}
export async function getReviews() {
  return getJson<{ reviews: Array<{
    _id?: string; name: string; message: string; rating?: number; created_at?: string;
  }> }>('/api/reviews');
}

// --- Contacts / Newsletter (mismo endpoint /api/contacts) ---
export type ContactPayload = {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  reason: number;
  message: string;
};
export async function submitContact(payload: ContactPayload) {
  return postJson('/api/contacts', payload);
}

export type NewsletterPayload = {
  email: string;
  reason: number; // usa 0 para newsletter
  name?: string;
  phone?: string;
  company?: string;
  message?: string;
};
export async function subscribeNewsletter(payload: NewsletterPayload) {
  return postJson('/api/contacts', payload);
}

// (opcional) exporta BASE por si lo necesitas en otros sitios
export { BASE, join, resolveBase };
